import { createGlobalStyle } from 'styled-components';
import reset from 'styled-reset';

const GlobalStyles = createGlobalStyle`
  ${reset};

  * {
    box-sizing: border-box;
  }

  html, body{
    background-color: #000;
  }

  body {
    font-size: 15px;
    line-height: 1.5;
    font-family: "Noto Sans KR", sans-serif;
    /* background-color: #121212; */
    color: ${props => props.theme.textColor};
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  img {
    display: block;
  }

  button {
    border: none;
    padding: 0;
    background-color: transparent;
    margin: 0;
    color: inherit;
    font-family: inherit;
    cursor: pointer;
    
  }

  .no-dragging {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  input, select, textarea {
    font-family: inherit;
  }

  table, th, td {
    border-collapse: collapse;
  }
`;

export default GlobalStyles;
